import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Italic 453",
  "use": "icon-Italic 453-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-Italic 453\"><path d=\"M729.173333 149.333333v64h-111.829333l-165.781333 618.666667h128.298666v64H277.333333v-64h107.968l165.76-618.666667H426.666667V149.333333h302.506666z\" p-id=\"28367\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol